//@ts-nocheck

export const Sandbox = () => {
    return (
        <div>
            <p>Sandbox One</p>
            <p>Sandbox Two</p>
        </div>
    );
};